export default __webpack_public_path__ + "static/lframe-calculator-budget-planner-0b33fb85c40f85ab8d048f18e39422b3.webp";